// @ts-nocheck

import { UserActionTypes } from '../../types/actions/user';
import { storage } from '../../utils';
import { type HandlerProps } from '../synchronousMiddleware';

export const handledActionTypes = [UserActionTypes.SET_PREFERENCES];

const onUserSetPreferencesMiddlewareHandler = ({ action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === UserActionTypes.SET_PREFERENCES) {
      const { id, prefs } = action.payload ?? {};

      switch (id) {
        case 'showWTV':
          storage.localStorage.save('application:prefs:show-wtv', prefs);
          break;
        case 'grids':
          storage.localStorage.save('application:prefs:grids', prefs);
          break;
        default:
          break;
      }
    }
  }
};

export default onUserSetPreferencesMiddlewareHandler;
